// format number to Euro
export const euro = Intl.NumberFormat('en-GR', {
    style: 'currency',
    currency: 'EUR',
});

